import type { ElementType, ReactNode } from "react";
import styles from "./Card.module.css";

export type CardTone = "flat" | "elevated" | "lead";

export function Card({
  as: Tag = "div",
  tone = "flat",
  className,
  children,
}: {
  as?: ElementType | undefined;
  tone?: CardTone | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  const toneClass = tone === "elevated" ? styles.elevated : tone === "lead" ? styles.lead : null;
  return (
    <Tag className={[styles.card, toneClass, className].filter(Boolean).join(" ")}>{children}</Tag>
  );
}
